import { displayOrDownloadUrlDocument, useDownloadDocument } from "@api";
import type { IDocument } from "@bbj-types/document";

export const useDrawerSocialOffer = () => {
  const [, downloadDocument] = useDownloadDocument();

  const handleGetDocument = async (document: IDocument, behaviour: "download" | "display" = "display") => {
    const result = await downloadDocument(document._id);
    if (result.status === 200) {
      void displayOrDownloadUrlDocument(result.data, behaviour, document.name, document.mimeType);
    }
  };

  return { handleGetDocument };
};
